import ProjectData from "@/data/ProjectData.ts";

const arcticaProject = new ProjectData(
  "project-3",
  "Aractica",
  "img/projects/Aractica/Aractica1.jpg",
  `
    <div class="paragraph">
        <strong>Aractica</strong> - A survival puzzle game set in the frozen wilderness.
        <br/><br/>
        You are the only one left to gather fish before the winter cold freezes the river. Move through cracked ice and obstacles, but take the shortest path you can. Every step counts, and winter is getting closer.
    </div>
    
    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/Aractica/Aractica3.jpg" alt="Aractica Gameplay Screenshot" />
    </div>
    
    <div class="paragraph center">
        <a href="https://tonkin.itch.io/aractica" target="_blank"><img src="img/itchiologo.svg" alt="Available on itch.io" class="platform-logo" /></a>
    </div>

    <div class="paragraph">
        <strong>Instructions:</strong>
        <ul>
        <li><strong>Click on the tile to move</strong> - Navigate carefully through the icy terrain</li>
        <li><strong>Collect Fishes</strong> - Gather all the fish before it's too late</li>
        <li><strong>Reach bonfire</strong> - Your only hope of survival against the cold</li>
        </ul>
    </div>

    <div class="paragraph">
        <strong>What I Built:</strong>
        <ul>
        <li><strong>Grid-Based Movement:</strong> Created a tile-based system where every click matters - had to make pathfinding feel intuitive</li>
        <li><strong>Puzzle Mechanics:</strong> Designed levels where finding the shortest route is key - longer paths mean more danger</li>
        <li><strong>Winter Atmosphere:</strong> Built a chilly, atmospheric world with cracked ice textures and survival tension</li>
        <li><strong>Obstacle System:</strong> Programmed cracked ice and barriers that force strategic thinking</li>
        <li><strong>Level Design:</strong> Crafted challenging but fair puzzles that ramp up the difficulty gradually</li>
        </ul>
    </div>
    
    <div class="paragraph">
        <div class="notice">
        <strong>Survival Challenge:</strong> Think carefully about your route - winter waits for no one! Available now on itch.io.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/Aractica/Aractica3.jpg" alt="Aractica Ice Navigation" />
        <img class="pc-screenshot" src="img/projects/Aractica/Aractica4.jpg" alt="Aractica Bonfire Scene" />
    </div>
    `,
  "#5DADE2",
  false
);

export default arcticaProject;
